'use client'

import { createContext, use, useLayoutEffect, type ReactNode } from 'react'

export type NavigationGuardDialogOptions = {
  title?: ReactNode
  description?: ReactNode
  cancelLabel?: string
  confirmLeavingLabel?: string
}

export type NavigationGuard = {
  isBlocked: () => boolean
  discard?: () => void
  onBeforeCancel?: () => void
  dialog?: NavigationGuardDialogOptions
}

type NavigationGuardContextValue = {
  requestNavigation: (navigate: () => void) => void
  setNavigationGuard: (guard: NavigationGuard | null) => void
}

export const NavigationGuardContext = createContext<NavigationGuardContextValue | null>(null)

export function useNavigationGuard() {
  const context = use(NavigationGuardContext)
  if (!context) throw new Error('useNavigationGuard must be used within NavigationGuardProvider')
  return context
}

export function useRegisterNavigationGuard(guard: NavigationGuard) {
  const { setNavigationGuard } = useNavigationGuard()

  useLayoutEffect(() => {
    setNavigationGuard(guard)
    return () => setNavigationGuard(null)
  }, [guard, setNavigationGuard])
}
